import { Link } from 'react-router-dom';

const CTASection = () => {
  return (
    <section className="py-24 bg-gradient-to-br from-gray-50 to-blue-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-0 rounded-3xl overflow-hidden shadow-2xl">
          <div className="relative bg-gradient-to-br from-gray-100 to-gray-200 min-h-[600px]">
            <img
              src="https://public.readdy.ai/ai/img_res/17d6b2efb17481bbaf3e7c96ae429a81.jpg"
              alt="Contatta Amaca"
              className="w-full h-full object-cover"
            />
            <div className="absolute bottom-0 left-0 right-0 p-12 bg-gradient-to-t from-black/80 to-transparent">
              <p className="text-sm text-gray-300 uppercase tracking-wider mb-4">Richiedi Informazioni</p>
              <h2 className="text-6xl md:text-7xl font-extrabold text-white leading-none">
                Contatta<br />
                <span className="text-7xl md:text-8xl">Il Nostro</span><br />
                <span className="text-8xl md:text-9xl">Team</span>
              </h2>
            </div>
          </div>
          
          <div className="bg-white p-12 md:p-16 flex flex-col justify-center">
            <h3 className="text-4xl md:text-5xl font-bold text-gray-900 mb-8 text-center leading-tight">
              Siamo Qui<br />Per Te
            </h3>
            
            <p className="text-lg text-gray-600 mb-12 text-center max-w-md mx-auto leading-relaxed">
              Contattaci per ricevere il listino prezzi riservato, informazioni sui prodotti disponibili o per richiedere un preventivo personalizzato. Il nostro team commerciale è a tua disposizione.
            </p>
            
            <div className="space-y-6 mb-12">
              <div className="flex items-center justify-center">
                <div className="w-12 h-12 flex items-center justify-center bg-blue-100 rounded-full mr-4">
                  <i className="ri-phone-line text-xl text-blue-600"></i>
                </div>
                <a href="tel:+393508628049" className="text-xl font-medium text-gray-900 hover:text-blue-600 cursor-pointer">
                  350 862 8049
                </a>
              </div>
              
              <div className="flex items-center justify-center">
                <div className="w-12 h-12 flex items-center justify-center bg-green-100 rounded-full mr-4">
                  <i className="ri-mail-line text-xl text-green-600"></i>
                </div>
                <a href="mailto:ordini.amacasrl@gmail.com" className="text-lg font-medium text-gray-900 hover:text-green-600 cursor-pointer break-all">
                  ordini.amacasrl@gmail.com
                </a>
              </div>
              
              <div className="flex items-center justify-center">
                <div className="w-12 h-12 flex items-center justify-center bg-purple-100 rounded-full mr-4">
                  <i className="ri-map-pin-line text-xl text-purple-600"></i>
                </div>
                <p className="text-base font-medium text-gray-900 text-center">
                  Via Don Domenico D'Angelo 31, Casandrino
                </p>
              </div>
            </div>
            
            <div className="text-center">
              <Link
                to="/contatti"
                className="inline-flex items-center justify-center bg-gray-900 text-white px-12 py-5 rounded-full text-lg font-semibold hover:bg-gray-800 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
              >
                Richiedi Listino Prezzi
                <i className="ri-arrow-right-line ml-3"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
